import React, { useState, useEffect, useContext } from "react";
import { ThemeContext } from "../../layout/BaseLayout";
import Draggable from "react-draggable";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { ModalDialog } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
// import TimezoneSelect from "react-timezone-select"
import Select from "react-select"
import * as FeedModulesService from "../../services/feedModulesService";
import { Loader } from "../../utils/loader";
import { hanldeSortingArray } from "../../utils/sortingByColumn";

const feedModuleAddModalDragModal = (props) => {
   return (
      <Draggable handle=".modal-header">
         <ModalDialog {...props} />
      </Draggable>
   );
};

function FeedModules(props) {
   let toast = useContext(ThemeContext);
   const [feedModuleAddModalShow, setFeedmasterAddModalShow] = useState(false);
   const [feedModuleCreationObj, setFeedModuleCreationObj] = useState({});
   const [feedModuleList, setFeedModuleList] = useState([]);
   const [isEdit, setIsEdit] = useState(false);
   const [loader, setLoader] = useState(false);
   const [disableSubmitBtn, setDisableSubmitBtn] = useState(false);
   const [feedNameError, setFeedNameError] = useState(false);
   const [feedDisplayNameError, setFeedDisplayNameError] = useState(false);
   const [feedDiscError, setFeedDiscError] = useState(false);
   const [selectedArr, setSelectedArr] = useState([]);
   let defaultSortingOrderObj = {
      sortingOrder: 'asc',
      upDownArrowColumn: null,
      fieldType: null
   };
   const [sortingOrderObj, setSortingOrderObj] = useState({ ...defaultSortingOrderObj });

   const feedModuleCreationDefaultObj = {
      "feedModuleId": 0,
      "feedModuleName": "",
      "feedModuleDesc": "",
      "feedModuleDisplayName": "",
      "feedModuleStatus": true,
   }

   useEffect(() => {
      getFeedModule();
   }, [])

   const onCreateFeedModule = () => {
      let isValid = true;
      setDisableSubmitBtn(true);

      if (feedModuleCreationObj["feedModuleName"] === '') {
         setFeedNameError(true);
         setDisableSubmitBtn(false);
         isValid = false;
      }

      if (feedModuleCreationObj['feedModuleDisplayName'] === '') {
         setFeedDisplayNameError(true);
         setDisableSubmitBtn(false);
         isValid = false;
      }

      if (feedModuleCreationObj['feedModuleDesc'] === '') {
         setFeedDiscError(true);
         setDisableSubmitBtn(false);
         isValid = false;
      }

      if (isValid) {
         FeedModulesService.createFeedModule(feedModuleCreationObj).then((res) => {
            if (res.isSuccess) {
               toast.success(!!res && !!res.successMessage && res.successMessage);
               setFeedmasterAddModalShow(false);
               getFeedModule();
               setFeedModuleCreationObj({ ...feedModuleCreationDefaultObj });
               setIsEdit(false);
               setDisableSubmitBtn(false);
            } else {
               toast.error(!!res && !!res.exception && !!res.exception.message && res.exception.message)
            }
         }).catch(e => {
            setDisableSubmitBtn(false);
         })
      }
   }

   const getFeedModule = () => {
      setLoader(true);
      FeedModulesService.getAllFeedModules().then((res) => {
         setLoader(false);
         if (res.isSuccess) {
            setFeedModuleList(!!res && !!res.data && res.data);
            setLoader(false);
         } else {
            toast.error(!!res && !!res.exception && !!res.exception.message && res.exception.message);
            setLoader(false);
         }
      }).catch(e => {
         setLoader(false);
      })
   }

   const onChange = (event) => {
      let name = event.target.name
      let value = event.target.value

      if (name === "feedModuleStatus") {
         value = (value === 'true')
      }

      let changeFeedModuleObj = { ...feedModuleCreationObj }
      changeFeedModuleObj[name] = value
      setFeedModuleCreationObj({ ...changeFeedModuleObj })
   }

   const openFeedModuleAddModal = () => {
      setFeedModuleCreationObj({ ...feedModuleCreationDefaultObj })
      setFeedmasterAddModalShow(true);
   }

   const editFeedModuleAddModal = (item) => {
      setIsEdit(true)
      setFeedModuleCreationObj({ ...item })
      setFeedmasterAddModalShow(true);
   }

   const closeFeedModuleAddModal = () => {
      setFeedModuleCreationObj({ ...feedModuleCreationDefaultObj })
      setFeedmasterAddModalShow(false);
      setIsEdit(false);
      setFeedNameError(false);
      setFeedDisplayNameError(false);
      setFeedDiscError(false);
   }

   const onSelectionRow = (item) => {
      if (!!feedModuleList && feedModuleList.length > 0) {
         const selectedRow = feedModuleList.map((elem) => { return elem.feedModuleId }).indexOf(item.feedModuleId);
         if (selectedRow > -1) {
            setSelectedArr([feedModuleList[selectedRow]]);
         }
      }
   }

   const checkItem = (item) => {
      const checkData = !!selectedArr && selectedArr.some((val) => val?.feedModuleId === item?.feedModuleId);
      return checkData;
   }

   const creatingSortingArrFn = (field, type) => {
      let order = sortingOrderObj.sortingOrder;
      if (field === sortingOrderObj.upDownArrowColumn) {
         order = order === 'asc' ? 'desc' : 'asc';
         setSelectedArr([]);
      } else {
         order = 'asc';
         setSelectedArr([]);
      }
      setSortingOrderObj({ sortingOrder: order, upDownArrowColumn: field, fieldType: type })
   }

   useEffect(() => {
      if (!!sortingOrderObj && sortingOrderObj.upDownArrowColumn !== '') {
         let sortedArrayByColumn = [...feedModuleList]
         sortedArrayByColumn = hanldeSortingArray(sortedArrayByColumn, sortingOrderObj.upDownArrowColumn, sortingOrderObj.fieldType, sortingOrderObj.sortingOrder)
         setFeedModuleList(sortedArrayByColumn);
      }
   }, [sortingOrderObj])

   return (
      <>
         <div id="tabs">
            {(!!loader && loader) && <Loader />}
            <div className="maintitle-box">
               <div className="w-75 d-inline-block">
                  <h2 className="maintitle "><img className="main-title-img" src={"/images/svg/feeder.svg"} alt="" />Feed Modules</h2>
                  {/* <p className="maintitle-text ">&nbsp;</p> */}
               </div>
               <div className="w-25 d-inline-block">
                  <div className="float-end ">
                     <div className="d-inline-block mr-3"><i id="feedModuleRefresh" className="fa fa-refresh font-size-14 remove_arrow_summary"
                        onClick={() => { getFeedModule(); }}></i>
                     </div>
                     <button className="addnewbtn mb-0" onClick={() => { openFeedModuleAddModal() }}>
                        <i className="fa-solid fa-circle-plus mr-2"></i>Add
                     </button>
                  </div>
               </div>
            </div>
            <div className="thead-fixed">
               <table className="table table-bordered table-strip w-100 mb-30 new-data-asc-desc">
                  <thead>
                     <tr className="thead-dard-bg">
                        <th className=" srn-width">Sr</th>
                        <th className={`feed-m-name sorting sorting_${sortingOrderObj.upDownArrowColumn === 'feedModuleName' && sortingOrderObj.sortingOrder === 'asc' ? 'asc' : 'desc'}`} onClick={() => creatingSortingArrFn('feedModuleName', 'Text')}>Module Name</th>
                        {/* <td className="w65-leverage">Secret Key</td> */}
                        <th className={`lic-domain sorting sorting_${sortingOrderObj.upDownArrowColumn === 'feedModuleDisplayName' && sortingOrderObj.sortingOrder === 'asc' ? 'asc' : 'desc'}`} onClick={() => creatingSortingArrFn('feedModuleDisplayName', 'Text')}>Module Display Name</th>
                        <th className={`sorting sorting_${sortingOrderObj.upDownArrowColumn === 'feedModuleDesc' && sortingOrderObj.sortingOrder === 'asc' ? 'asc' : 'desc'}`} onClick={() => creatingSortingArrFn('feedModuleDesc', 'Text')}>Module Desc </th>
                        <th className={`lic-status sorting sorting_${sortingOrderObj.upDownArrowColumn === 'feedModuleStatus' && sortingOrderObj.sortingOrder === 'asc' ? 'asc' : 'desc'}`} onClick={() => creatingSortingArrFn('feedModuleStatus', 'Status')}>Status </th>
                     </tr>
                  </thead>
                  <tbody>
                     {!!feedModuleList && feedModuleList.length > 0 && feedModuleList.map((item, i) => {
                        return (
                           <tr key={"feedModuleList" + i} onDoubleClick={() => { editFeedModuleAddModal(item) }} onClick={() => onSelectionRow(item)}
                              className={`${!item.feedModuleStatus && "gray-text"} ${checkItem(item) ? 'selected-tr' : ''} `}>
                              <td className="">{i + 1}</td>
                              <td className="">{item.feedModuleName}</td>
                              <td className="">{item.feedModuleDisplayName}</td>
                              <td className="">{item.feedModuleDesc}</td>
                              <td className="">{item.feedModuleStatus ? "Active" : "Inactive"}</td>
                           </tr>
                        )
                     })}
                  </tbody>
               </table>
            </div>
         </div>
         <div className="login-popup">
            <Modal
               className="login feed-modules"
               show={feedModuleAddModalShow}
               onHide={() => closeFeedModuleAddModal()}
               backdrop="static"
               dialogAs={feedModuleAddModalDragModal}
               animation={false}
               size="md"
               centered
            >
               <Modal.Header closeButton style={{ border: "none" }}>
                  <Modal.Title className="w-100">
                     Feed Modules
                     <div className="btn-help d-inline-block float-right ">
                        {/* <i className="fa-question fa-solid font-size-16 mt-1"></i> */}
                     </div>
                  </Modal.Title>
               </Modal.Header>
               <Modal.Body style={{ display: "flex", flexDirection: "column" }}>
                  <div>
                     <div className="fidderbox-inner office-feed-height">
                        <div className="">
                           <table border="0" cellSpacing="0" cellPadding="0" className="w-100">
                              <tbody>
                                 <tr>
                                    <td className="office-w80 font11 text-right font11 v-align-baseline">Name:</td>
                                    <td className={`feederw-430 loginUser ${feedNameError && 'error'}`}>
                                       <input type="text" className="inputborder font11 w-100  ml-2 h20 mb-2" name="feedModuleName" value={!!feedModuleCreationObj["feedModuleName"] ? feedModuleCreationObj["feedModuleName"] : ""} onChange={(e) => { onChange(e); (e.target.value === "" ? setFeedNameError(true) : setFeedNameError(false)) }} autoComplete="off" maxLength={100} autoFocus /></td>
                                    <td className="feederw-100 font11 text-right font11">&nbsp;</td>
                                 </tr>
                                 <tr>
                                    <td className="office-w80 font11 text-right font11 v-align-baseline">Display Name:</td>
                                    <td className={`feederw-430 text-right false ${feedDisplayNameError && 'error'}`}>
                                       <input type="text" className="inputborder font11 w-100  ml-2 h20 mb-2" name="feedModuleDisplayName" value={!!feedModuleCreationObj["feedModuleDisplayName"] ? feedModuleCreationObj["feedModuleDisplayName"] : ""} onChange={(e) => { onChange(e); (e.target.value === '' ? setFeedDisplayNameError(true) : setFeedDisplayNameError(false)) }} autoComplete="off" maxLength={200} /> </td>
                                    <td className="feederw-100 font11 text-right font11">&nbsp;</td>
                                 </tr>
                                 <tr>
                                    <td className="office-w80 font11 text-right font11 v-align-baseline">Description:</td>
                                    <td className={`feederw-430 ${feedDiscError && 'error'}`}>
                                       <input type="text" className="inputborder font11 w-100  ml-2 h20 mb-2" maxLength={500} name="feedModuleDesc" value={!!feedModuleCreationObj["feedModuleDesc"] ? feedModuleCreationObj["feedModuleDesc"] : ""} onChange={(e) => { onChange(e); (e.target.value === '' ? setFeedDiscError(true) : setFeedDiscError(false)) }} autoComplete="off" /></td>
                                    <td className="feederw-100 font11 text-right font11">&nbsp;</td>
                                 </tr>
                                 <tr>
                                    <td className="symbolrw-150 text-right font11 ">Status:</td>
                                    <td colspan="2" className="symbolrw-430 officeuser-redio-feed">
                                       <div className="form-check-inline width-50 mb-2 mr-4">
                                          <label className="form-check-label marginleft25group">
                                             <input type="radio" className="form-check-input mt-1" name="feedModuleStatus" value={true} onChange={(e) => { onChange(e) }} checked={!!feedModuleCreationObj && !!feedModuleCreationObj.feedModuleStatus} />Yes
                                          </label>
                                       </div>
                                       <div className="form-check-inline width-50">
                                          <label className="form-check-label ml-3">
                                             <input type="radio" className="form-check-input mt-1" name="feedModuleStatus" value={false} onChange={(e) => { onChange(e) }} checked={!!feedModuleCreationObj && !feedModuleCreationObj.feedModuleStatus} />No
                                          </label>
                                       </div>
                                    </td>
                                    <td className="feederw-100 font11 text-right font11">&nbsp;</td>
                                 </tr>
                              </tbody>
                           </table>
                        </div>
                     </div>
                  </div>
               </Modal.Body>
               <Modal.Footer>
                  <div>
                     <div className="w-100 text-right p-1">
                        <Button className="btnmain mr-3" onClick={() => { onCreateFeedModule() }} disabled={disableSubmitBtn}>
                           {disableSubmitBtn && <i className="fa fa-spinner fa-spin mr-2"></i>}Submit
                        </Button>
                        <Button onClick={() => closeFeedModuleAddModal()} className="btnmain-danger">
                           Cancel
                        </Button>
                     </div>
                  </div>
               </Modal.Footer>
            </Modal>
         </div>
      </>
   );

}
export default FeedModules;
